import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LicensesComponent } from './licenses.component';

const routes: Routes = [
  {path: 'licenses', component: LicensesComponent, data: {title: 'Licenses'}}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class LicensesRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/licenses/licenses-routing.module.ts